import { fn } from 'storybook/test';
import { useState } from 'react';

import type { Meta, StoryFn } from '@storybook/react';
import type { MultiSelectBoxProps, MultiSelectData } from './MultiSelectBox';

import { MultiSelectBox } from './MultiSelectBox';

const codeString = `<MultiSelectBox selectData={[{label, value}]} onChange={fn} labelSuffix={string} />`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/MultiSelectBox',
  component: MultiSelectBox,
  argTypes: {
    onChange: {
      action: 'Selected values',
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: MultiSelectBox,
    codeString: codeString,
  },
} as Meta<MultiSelectBoxProps>;

const mockItems = [
  { label: 'A.B. Docent', value: '1' },
  { label: 'B.C. Docent met lange achternaam', value: '2' },
  {
    label: 'prof. F.G. Docent met lang achternaam',
    value: '3',
  },
  { label: 'H.I. Docent', value: '4' },
  { label: 'K.L. Docent ', value: '5' },
  { label: 'A.B. Docent', value: '6' },
  { label: 'B.C. Docent met lange achternaam', value: '7' },
  {
    label: 'prof. F.G. Docent met lang achternaam',
    value: '8',
  },
  { label: 'H.I. Docent', value: '9' },
  { label: 'K.L. Docent ', value: '10' },
];

const Template: StoryFn<MultiSelectBoxProps> = (args) => {
  const [selectedItems, setSelectedItems] = useState<MultiSelectData[]>(args.defaultSelectedItems || []);

  const handleChange = (items: MultiSelectData[]) => {
    if (args.onChange) {
      args.onChange(items);
    }
    setSelectedItems(items);
  };

  return (
    <div style={{ width: '30rem', margin: '0rem auto 0 auto' }}>
      <span>{selectedItems.map((item) => item.label).join(', ')}</span>
      <MultiSelectBox {...args} onChange={handleChange} />
    </div>
  );
};

const defaultArgs: Partial<MultiSelectBoxProps> = {
  fullWidth: false,
  labelSuffix: 'geselecteerd',
  maxOptionHeight: '20rem',
  optionPositionRight: false,
  disabled: false,
  selectData: mockItems,
  onChange: fn(),
};

export const MultiSelectBoxExample = Template.bind({});
MultiSelectBoxExample.args = {
  ...defaultArgs,
};

export const WithDefaultSelectedItems = Template.bind({});
WithDefaultSelectedItems.args = {
  ...defaultArgs,
  defaultSelectedItems: [
    { label: 'A.B. Docent', value: '1' },
    { label: 'H.I. Docent', value: '4' },
    { label: 'A.B. Docent', value: '6' },
  ],
};
